import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import ReportService from '../../service/report-service';

import FileSaver from 'file-saver';
import ActivityService from '../../service/activity-service'

import { Spinner } from 'react-bootstrap';
import {ModalAlert} from '../template/modal-alert';
import i18n from '../../i18n';

export default class GetPdf extends Component {

    constructor(props) {
        super(props);
        this.state = {
            downloading: false,
        };
        this.handleDownload = this.handleDownload.bind(this);
    }

    handleDownload(reportType, language) {

        if (this.state.downloading) {
            return;
        }

        let self = this;
        self.setState({
            downloading: true
        })
        ReportService.getPermReportPdf(this.props.hash, this.props.linkId, this.props.documentName, this.props.reportType, language).then(response => {
            if (response.data.error != null) {
                ModalAlert(error.response.data.error.errorMsg, i18n.t("modal:greska"), i18n.t("modal:zatvori"));
            } else {
                var binaryString = window.atob(response.data.pdf);
                var binaryLen = binaryString.length;
                var bytes = new Uint8Array(binaryLen);
                for (var i = 0; i < binaryLen; i++) {
                    var ascii = binaryString.charCodeAt(i);
                    bytes[i] = ascii;
                }
                var newBlob = new Blob([bytes], { type: "application/pdf" });

                FileSaver.saveAs(newBlob, response.data.reportName);
                self.setState({
                    downloading: false
                });
            }

        }).catch(error => {
            ModalAlert(error.response.data.error.errorMsg, i18n.t("modal:greska"), i18n.t("modal:zatvori"));
            self.setState({
                downloading: false
            });
        });

        //Activity record
        if (reportType != null) {
            var simpleReport = 0;
            var detailedReport = 0;
            var diagnosticReport = 0;
            if (reportType == 0) {
                simpleReport = 1;
            } else if (reportType == 1) {
                detailedReport = 1;
            } else {
                diagnosticReport = 1;
            }

            ActivityService.recordActivity(0, 0, 1, 0, simpleReport, detailedReport, diagnosticReport, this.props.linkId).then(response => {
            }).catch(error => {
                ModalAlert(error.response.data.error.errorMsg, i18n.t("modal:greska"), i18n.t("modal:zatvori"));
            });
        }
    }

    render() {
        return (
            <React.Fragment>
                {this.state.downloading ?
                    <Spinner animation="border" role="status">
                        <span className="sr-only">Loading...</span>
                    </Spinner>
                    :
                    <React.Fragment>
                        {this.props.button ?
                            <button style={{ "backgroundColor": "transparent", "border": "none" }} >
                                <i className="material-icons align-middle" aria-hidden="true">file_download</i>
                                <span>{i18n.t("getPdf:download_pdf_button")}</span>
                            </button>
                            :
                            <span style={{ "cursor": "pointer" }} >
                                <i className="material-icons align-middle" aria-hidden="true">file_download</i>
                            </span>
                        }
                    </React.Fragment>
                }
            </React.Fragment>
        )
    }
}